<template>
	<div class='tax-data'>
		<table class='tax-table table-common'>
			<thead>
				<tr>
					<th rowspan='3'>№ выдела</th>
					<th rowspan='3'>Площадь, га</th>
					<th rowspan='3'>Ярус</th>
					<th rowspan='3'>Состав</th>
					<th rowspan='3'>Доля участия породы</th>
					<th rowspan='3'>Порода</th>
					<th rowspan='3'>Возраст, лет</th>
					<th rowspan='3'>Высота, м</th>
					<th rowspan='3'>Диаметр, см</th>
					<th rowspan='3'>Бонитет</th>
					<th rowspan='3'>Тип леса</th>
					<!--<th rowspan='3'>ТЛУ</th>-->
					<th rowspan='3'>Полнота</th>
					<th rowspan='3'>Запас, куб.м/га</th>
					<th colspan='5'>Запас на выделе, кбм</th>
				</tr>
				<tr>
					<th rowspan='2'>Сухостоя (старого)</th>
					<th rowspan='2'>Редин</th>
					<th rowspan='2'>Единич. дер.</th>
					<th colspan='2'>Захламленность</th>
				</tr>
				<tr>
					<th>общая</th>
					<th>ликвида</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for='(item, item_i) in selectedTax'>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.section }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.s }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.layer == 11 ? 'единичные деревья': item.layer  }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.composition }}</td>
					<td>{{ item.coeff !== '0' ? item.coeff : '+' }}</td>
					<td>{{ item.species_name }}</td>
					<td>{{ item.age }}</td>
					<td>{{ item.h }}</td>
					<td>{{ item.d }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.bonitet }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.forest_type }}</td>
					<!--<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.tlu }}</td>-->
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.fullness }}</td>
					<td v-if='isStartLayer(item)' :rowspan='getLayerRowCount(item)'>{{ item.stock }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_dead }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_open_stand }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_single_tree }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_felling_debris }}</td>
					<td v-if='item_i === 0' :rowspan='selectedTax.length'>{{ item.stock_liquid_debris }}</td>
				</tr>
			</tbody>
		</table>

		<div class='underwood-block' v-if='selectedTax.length && selectedTax[0].underwood'>
			<span><span class='underwood-label'>Подрост:</span> {{ selectedTax[0].underwood }}</span>
		</div>

		<div class='accept-btn-block'>
			<p-button icon='fa fa-edit' @click='goEditTax' label='Перейти к редактированию ТО' class='p-button-sm p-mr-2'/>
		</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex';

	export default {
		name: 'TaxData',
		computed: {
			startLayerList() {
				const result = [];
				for (const item of this.selectedTax) {
					if (!result.find(row => row.layer === item.layer)) {
						result.push(item);
					}
				}
				return result;
			},

			...mapState('selectedLpo', {
				lpo: state => state.lpo,
				selectedTax: state => state.taxData
			}),

			...mapState('lpoData', {
				taxData: state => state.taxData
			})
		},
		methods: {
			isStartLayer(item) {
				return this.startLayerList.find(row => row.tax_species_id === item.tax_species_id);
			},
			getLayerRowCount(item) {
				return this.selectedTax.filter(row => row.layer === item.layer).length;
			},

			layerSpeciesCount(layer) {
				return layer.species.filter(species => species.is_extra !== 't').length;
				
			},

			totalSpeciesCount() {
				let num = 0;

				for (const layer of this.selectedTax.layers) {
					num += this.layerSpeciesCount(layer);
				}

				return num;
			},

			goEditTax() {
				const lpo = this.lpo;

				const route_obj = {
					name: 'tax-info',
					params: {
						tax_id: this.selectedTax[0].tax_id,

						lpo_id: this.lpo.lpo_id,

						fo: { id: lpo.fo_id, name: lpo.fo },
						region: { id: lpo.region_id, name: lpo.region },
						forestry: { id: lpo.forestry_id, name: lpo.forestry },
						localforestry: { id: lpo.localforestry_id, name: lpo.localforestry },
						subforestry: { id: lpo.subforestry_id, name: lpo.subforestry },
						area: { id: lpo.locality_id, name: lpo.area },
						section: lpo.section
					}
				};
				this.$router.push(route_obj);
			},

			...mapActions('lpoData', [
				'getTaxData'
			])
		},

		created() {
			this.getTaxData();
		},

		beforeDestroy() {

		},
	};
</script>

<style scoped src='@/style/table.css'></style>
<!-- <style lang='scss' scoped src='@/style/tables.scss'></style> -->

<style scoped>
	.underwood-block {
		margin-top: 10px;
	}
	.underwood-label {
		font-style: italic;
		font-weight: bold;
	}

	.accept-btn-block {
		margin-top: 20px;
	}

	.tax-data__upload-btn {
		display: inline-block;
	}

	.tax-data__upload-btn >>> .p-button {
		font-size: 0.875rem !important;
		padding: 0.4375rem 0.875rem!important;
	}
</style>